export const REDUCER_NAME = "homeNewsSection";
export const SET_ERROR = `${REDUCER_NAME}/SET_ERROR`;
export const SET_HOMENEWS = `${REDUCER_NAME}/SET_HOMENEWS`;
export const RESET_HOMENEWS = `${REDUCER_NAME}/RESET_HOMENEWS`;
